import React from "react"
import { Container, Row, Col, Spacer, Card } from "@cleartrip/bento/lib"
import { CopyToClipboard } from "react-copy-to-clipboard"

import Layout from "../gatsby-theme-docz/templates/master"
import Icon from "@components/Icon"
import Header from "@components/Header"
import Jumbotron from "@components/Jumbotron"
import Footer from "@components/Footer"
import Sandbox from "@components/Sandbox"

const Home = () => {
  return (
    <Layout>
      <Header page="index" />
      <Jumbotron />
      <Spacer my={10} />

      <Container>
        <Row>
          <Col>
            <h1 className="fs-heading fw-600">Installation and Usage</h1>
          </Col>
        </Row>
        <Spacer my={5} />
        <Row>
          <Col span={11}>
            <Card className="bg-transparent br-4 ">
              <p className="fs-6 fw-500">Bento</p>
              <Spacer className="pt-5" />
              <p className="fs-4 c-neutral-800">
                Install bento using npm or yarn
              </p>
              <Spacer className="pt-3" />
              <div className="p-relative">
                <CopyToClipboard text="npm install @cleartrip/bento">
                  <Icon
                    icon="copy"
                    className="c-pointer c-neutral-400 r-4 p-absolute z-10 t-4"
                    height={20}
                    width={18}
                  />
                </CopyToClipboard>
                <Sandbox theme="light">
                  <Sandbox.Text>
                    $ npm install @cleartrip/bento
                  </Sandbox.Text>
                </Sandbox>
              </div>
              <Spacer className="pt-5" />
              <p className="fs-4 c-neutral-800">
                Easily use the components in your project
              </p>
              <Spacer className="pt-3" />
              <Sandbox theme="light">
                <Sandbox.Text>
                  import React from 'react'
                  <br />
                  import {"{ Button }"} from '@cleartrip/bento'
                  <br />
                  <br />
                  {'<Button type="primary">Hello World</Button>'}
                </Sandbox.Text>
              </Sandbox>

              <Spacer className="pt-5" />
              <p className="fs-4 c-neutral-800">And add the css</p>
              <Spacer className="pt-3" />
              <div className="p-relative">
                <CopyToClipboard text="@import '@cleartrip/bento/bento.css'">
                  <Icon
                    icon="copy"
                    className="c-pointer c-neutral-400 r-4 p-absolute z-10 t-4"
                    height={20}
                    width={18}
                  />
                </CopyToClipboard>
                <Sandbox theme="light">
                  <Sandbox.Text>
                    @import '@cleartrip/bento/bento.css'
                  </Sandbox.Text>
                </Sandbox>
              </div>
            </Card>
          </Col>
          <Col span={2} />
          <Col span={11}>
            <Card className="bg-transparent br-4">
              <p className="fs-6 fw-500">Bento Icons</p>
              <Spacer className="pt-5" />
              <p className="fs-4 c-neutral-800">
                Install bento icons using npm or yarn
              </p>
              <Spacer className="pt-3" />
              <div className="p-relative">
                <CopyToClipboard text="npm install @cleartrip/bento-icons">
                  <Icon
                    icon="copy"
                    className="c-pointer c-neutral-400 r-4 p-absolute z-10 t-4"
                    height={20}
                    width={18}
                  />
                </CopyToClipboard>
                <Sandbox theme="light">
                  <Sandbox.Text>
                    $ npm install @cleartrip/bento-icons
                  </Sandbox.Text>
                </Sandbox>
              </div>
              <Spacer className="pt-5" />
              <p className="fs-4 c-neutral-800">
                Use the bento icons without any additional setup
              </p>
              <Spacer className="pt-3" />
              <Sandbox theme="light">
                <Sandbox.Text>
                  import React from 'react'
                  <br />
                  import {"{ Flights }"} from '@cleartrip/bento-icons'
                  <br />
                  <br />
                  {'<Flights className="c-secondary-500" />'}
                </Sandbox.Text>
              </Sandbox>
            </Card>
          </Col>
        </Row>
        <Spacer my={10} />
        <Row>
          <Col span={12}>
            <h1 className="fs-heading fw-600">Guiding Priciples</h1>

            <Spacer my={5} />

            <div className="flex flex-top">
              <div className="w-10p">
                <Icon icon="reuse" className="current-fill c-blue" />
              </div>
              <div className="ml-6">
                <p className="fs-body-3 fw-500 mb-2">Reuse over reinvent</p>
                <p className="fs-body-2 lh-copy c-grey-80">
                  All Bento components are built with the intention of reuse.
                  It's flexible api's allow it to be used in various contexts.
                </p>
              </div>
            </div>

            <Spacer my={5} />

            <div className="flex flex-top">
              <div className="w-10p">
                <Icon icon="increase" className="current-fill c-blue" />
              </div>
              <div className="ml-6">
                <p className="fs-body-3 fw-500 mb-2">Increase efficiency</p>
                <p className="fs-body-2 lh-copy c-grey-80">
                  Bento enables complex interfaces to be built rapidly thereby
                  freeing up time for focusing on other critical tasks
                </p>
              </div>
            </div>

            <Spacer my={5} />

            <div className="flex flex-top">
              <div className="w-10p">
                <Icon icon="idea" className="current-fill c-blue" />
              </div>
              <div className="ml-6">
                <p className="fs-body-3 fw-500 mb-2">Evolve and adapt</p>
                <p className="fs-body-2 lh-copy c-grey-80">
                  This system will always be a work in progress. It will evolve
                  and adapt according to the design and development requirements
                </p>
              </div>
            </div>

            <Spacer my={5} />

            <div className="flex flex-top">
              <div className="w-10p">
                <Icon icon="speech" className="current-fill c-blue" />
              </div>
              <div className="ml-6">
                <p className="fs-body-3 fw-500 mb-2">Establish Vocabulary</p>
                <p className="fs-body-2 lh-copy c-grey-80">
                  Bento bridges the gap between designers and developers and
                  allows them to communicate using a shared vocabulary.
                </p>
              </div>
            </div>
          </Col>

          <Col span={8} offset={4}>
            <h1 className="fs-heading fw-600">Resources</h1>

            <Spacer my={5} />

            <a
              href="https://app.abstract.com/projects/e51fe7ff-a100-4a77-b59d-7226ede4c28a"
              target="_blank"
              rel="noopener noreferrer"
              className="td-none c-inherit d-block"
            >
              <div className="ba bc-neutral-100 p-5 br-4 hover:bg-neutral-0 c-pointer flex flex-middle">
                <Icon
                  icon="sketch"
                  className="mr-4 current-fill c-grey-70 w-30 h-8"
                />
                <p className="fs-body-2 fw-500 c-grey-60">
                  Download Sketch library
                </p>
              </div>
            </a>

            <Spacer my={2} />

            <a
              href="https://bitbucket.org/cleartrip/bento/"
              target="_blank"
              rel="noopener noreferrer"
              className="td-none c-inherit d-block"
            >
              <div className="ba bc-neutral-100 p-5 br-4 hover:bg-neutral-0 c-pointer flex flex-middle">
                <Icon
                  icon="bitbucket"
                  className="mr-4 current-fill c-slate h-8 w-30"
                />
                <p className="fs-body-2 fw-500 c-grey-60">
                  Visit Bitbucket repository
                </p>
              </div>
            </a>
            <Spacer my={2} />

            <a
              href="https://www.npmjs.com/package/@cleartrip/bento"
              target="_blank"
              rel="noopener noreferrer"
              className="td-none c-inherit d-block"
            >
              <div
                style={{ minHeight: "74px" }}
                className="ba bc-neutral-100 px-5 br-4 hover:bg-neutral-0 c-pointer flex flex-middle"
              >
                <Icon icon="npm" className="mr-4 current-fill c-slate w-30" />
                <p className="fs-body-2 fw-500 c-grey-60">
                  Visit Bento npm package
                </p>
              </div>
            </a>

            <Spacer my={2} />

            <a
              href="https://www.npmjs.com/package/@cleartrip/bento-icons"
              target="_blank"
              rel="noopener noreferrer"
              className="td-none c-inherit d-block"
            >
              <div
                style={{ minHeight: "74px" }}
                className="ba bs-border bc-neutral-100 px-5 br-4 hover:bg-neutral-0 c-pointer flex flex-middle"
              >
                <Icon icon="npm" className="mr-4 current-fill c-slate w-30" />
                <p className="fs-body-2 fw-500 c-grey-60">
                  Visit Bento Icons npm package
                </p>
              </div>
            </a>
          </Col>
        </Row>
      </Container>

      <Spacer my={15} />

      <Footer />
    </Layout>
  )
}

export default Home
